import { logAndToast } from './logAndToast';
import { type LogHelper, LogLevels } from '@types';
import { writeIntoLogs } from '@lib/logger/writeIntoLogs.ts';

export const logInfo: LogHelper = async (
  message,
  source,
  context,
  showToast = false,
  forceLog = false
): Promise<void> => {
  await logAndToast({
    message,
    source,
    context,
    toast: showToast,
    level: 'info',
    forceLog
  });
};

export async function writeInfoLog<T> (message: string, source: string, context: Record<string, T>): Promise<void> {
  await writeIntoLogs({
    message,
    level: LogLevels.INFO,
    source,
    context
  });
}